import { Component, OnInit, inject, input, output, signal } from '@angular/core';
import { NavController } from '@ionic/angular';

import { ConsentService } from 'src/app/services/consent/consent.service';

/**
 * Banner de consentimiento. Sólo emite la decisión: quien la persiste es el
 * contenedor (AppComponent o la página de política de cookies) a través de
 * ConsentService, para que el componente siga siendo tonto y testeable.
 *
 * En `mode="panel"` se reutiliza dentro de /politica-de-cookies/ como panel de
 * preferencias, ya abierto y con el estado guardado cargado.
 */
@Component({
    selector: 'app-cookies-bar',
    templateUrl: './cookies-bar.component.html',
    styleUrls: ['./cookies-bar.component.scss'],
    standalone: false
})
export class CookiesBarComponent implements OnInit {
  private nav = inject(NavController);
  private consentSrv = inject(ConsentService);


  readonly mode = input<'banner' | 'panel'>('banner');

  readonly consent = output<McConsentPrefs>();

  readonly showPrefs = signal(false);

  /**
   * Estado del formulario: lo escribe `ngModel` directamente sobre el objeto, que es lo
   * que marca la vista como sucia. Por eso no es señal.
   */
  prefs: McConsentPrefs = { analytics: false, ads: false, personalization: false };

  ngOnInit() {
    if (this.mode() !== 'panel') return;

    this.showPrefs.set(true);
    const state = this.consentSrv.get();
    if (state) {
      this.prefs = {
        analytics: state.analytics,
        ads: state.ads,
        personalization: state.personalization
      };
    }
  }

  acceptAll() {
    this.emit({ analytics: true, ads: true, personalization: true });
  }

  rejectAll() {
    this.emit({ analytics: false, ads: false, personalization: false });
  }

  saveSelection() {
    this.emit({ ...this.prefs });
  }

  goTo(data: string) {
    this.nav.navigateForward(data);
  }

  private emit(prefs: McConsentPrefs) {
    this.prefs = prefs;
    this.consent.emit(prefs);
  }
}
